export function init_customers() {

  $(function(){
    const rhd = $('#customers_industry_cd').find("option:selected").data('rhd');
    display_attachment_file(rhd);

    const target_attachement_cont = $("#attachement_cont").html();
    const biz_attachement_cont = $("#biz_attachement_cont").html();

    // ----------------------------------------
    // 休診日・定休日（祝日）
    // ----------------------------------------
    $('.all_hol_flg_am, .all_hol_flg_pm').change(function() {
      const checked = $(this).prop('checked');
      const class_name = $(this).attr('class');

      $('.' + class_name).prop('checked', checked)
    });

    // ----------------------------------------
    // 業種選択による表示/非表示
    // ----------------------------------------
    $('#customers_industry_cd').change(function() {
      const selected = $(this).find('option:selected');
      const rhd = selected.data('rhd');

      // 必要書類表示
      display_attachment_file(rhd);
    });

    // ----------------------------------------
    // 業態の表示/非表示
    // ----------------------------------------
    $('input[name="customers[industry_div]"]').change(function() {
      // Biz選択で業態を表示
      if ($("#customers_industry_div_0").is(":checked")) {
        $("#business_type").show();
        if ($("#customers_business_type_1").is(":checked")) {
          display_biz_attachment_file()
        }
      } else {
        $('input[name="customers[business_type]"]').prop('checked', false);
        $("#business_type").hide();
        $("#attachement_cont").html(target_attachement_cont);
        display_attachment_file(false)
      }
    });

    $('input[name="customers[business_type]"]').change(function() {
      // 個人事業主選択で必要書類表示
      if ($("#customers_business_type_1").is(":checked")) {
        display_biz_attachment_file()
      } else {
        display_attachment_file(false)
      }
    });

    if ($("#customers_industry_div_0").is(":checked")) {
      $("#business_type").show();
      if ($("#customers_business_type_1").is(":checked")) {
        display_biz_attachment_file()
      }
    }

    // ----------------------------------------
    // 必要書類表示
    // ----------------------------------------
    function display_attachment_file(rhd) {
      if(rhd == true) {
        $('#attachment_file').show();
        $('customers_attachment_file').prop('disabled', false);
      } else {
        $('#attachment_file').hide();
        $('customers_attachment_file').prop('disabled', true);
      }
    }

    // ----------------------------------------
    // Biz必要書類表示
    // ----------------------------------------
    function display_biz_attachment_file() {
      $("#attachement_cont").html(biz_attachement_cont);
      display_attachment_file(true)
    }

    // ====================
    // 郵便番号編集時（新規登録 社販）
    // ====================
    if ($('.js-employee-customers').length) {
      const BANNED_PREFS = new Set([
        '沖縄県'
      ]);
      const pref = $('#customers_prefecture');
      const zip  = $('.p-postal-code'); 
      const addr = $('#customers_address1, #customers_address2');
      const MSG_BANNED = '入力された郵便番号はAWG社販カタログの対象外エリアです';

      pref.find('option').each(function () {
        const val = $(this).val();
        if (BANNED_PREFS.has(val)) {
          $(this).addClass('hidden')
        }
      });

      function enforceBan() {
        const val = (pref.val() || '').trim();
        if (BANNED_PREFS.has(val)) {
          alert(MSG_BANNED);
          pref.val('');
          addr.val('');
        }
      };

      zip.on('focusout', enforceBan);
    }
  });
}
